import React from 'react'
import {Link, useLocation, matchPath} from 'react-router-dom'

export default ({collection, active, className = '', boxed = true, includeSearch = true}) => {
  const {pathname, search} = useLocation()
  const carriedSearch = search.replace(/&?(page|limit)=\d+/gi, '')

  if (!active) {
    // Check exact match first, or fall back to prefix match
    let tab = collection.find(({to, exact}) =>
      matchPath(pathname, {path: to, exact: exact ?? to.split('/').length === 4})
    )

    // Fallback: match most specific URL by longest matching path length
    if (!tab) {
      const matches = collection
        .filter(({to}) => matchPath(pathname, {path: to, exact: false}))
        .sort((a, b) => b.to.length - a.to.length)
      tab = matches[0]
    }

    active = tab ? tab.label : null
  }

  return (
    <div className={`tabs ${boxed ? 'is-boxed' : ''} ${className}`}>
      <ul className='container'>
        {collection.map(({label, to}, i) => (
          <li key={i} className={active === label ? 'is-active has-text-weight-semibold' : ''}>
            <Link to={`${to}${includeSearch ? carriedSearch : ''}`} className='is-decorationless'>
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
